export const baseTheme = {
  typography: {
    fontSize: {
      xs: '10px',
      sm: '12px',
      md: '14px',
      lg: '16px',
      xl: '18px',
      '2xl': '24px',
      '3xl': '36px',
      '4xl': '42px',
      '5xl': '72px',
    },
    fontWeight: {
      thin: 100,
      extraLight: 200,
      light: 300,
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
      extraBold: 800,
      black: 900,
    },
  },
  colors: {
    white: '#FFFFFF',
    dark: '#000000',
    lightDark: '#111827',
    dark100: '#232D42',
    buttonDark: '#343039',
    buttonGrey: '#adb5bd',
    primaryColor: '#081c1d',
    darkRed: '#9B1C1C',
    red: '#F05252',
    lightRed: '#fbd5d5',
    green: '#5aae88',
    lightGreen: '#6cc49e',
    green100: '#0E9F6E',
    darkGreen: '#0e2a2b',
    turquoise: '#436c6c',
    darkTurquoise: '#163939',
    greyTurquoise: '#6B7280',
    blueGreen: '#1d4747',
    lightGrey: '#E5E7EB',
    middleDark: '#28252D',
    greySoft: '#F9FAFB',
    nearWhite: '#F3F4F6',
    yellow: '#fcc701',
    blueGrey: '#9fb5b6',
    iconGrey: '#cfdada',
    iconLightGrey: '#ecf4f4',
    lightBlue: '#58B0E1',
    violet: '#743BBC',
    lightViolet: '#743BBC33',
    darkGrey: '#4B5563',
    purple: '#B652BF',
    greyBlue: '#EAEAEA',
    softGrey: '#E3E3E3',
    grey: '#8A92A6',
    required: '#F03738',
    grey3: '#999ca3',
  },
  gradients: {
    violet: 'linear-gradient(180deg, #743bbc 0%, #8f5ccf 100%)',
    dark: 'linear-gradient(180deg, #343039 0%, #3a4051 100%)',
    light: 'linear-gradient(180deg, #FBFBFB 0%, #FBFBFB 0.01%, rgba(255, 255, 255, 0.526042) 47.4%, #F7F4F4 100%)',
    grey: 'linear-gradient(180deg, #FBFBFB 0%, #FFFFFF 0.01%, rgba(231, 231, 231, 0.526042) 47.4%, #FFFBFB 100%)',
  },
  device: {
    mobileS: '(min-width: 320px)',
    mobileM: '(min-width: 375px)',
    mobileL: '(min-width: 560px)',
    tablet: '(min-width: 960px)',
    laptop: '(min-width: 1199px)',
    desktop: '(min-width: 1440px)',
    desktopL: '(min-width: 1920px)',
  },
}

export const themePrimsell = {
  primary: {
    main: baseTheme.colors.violet,
    light: baseTheme.colors.iconGrey,
    dark: baseTheme.colors.iconLightGrey,
  },
  secondary: {
    main: baseTheme.colors.lightGrey,
    light: baseTheme.colors.blueGrey,
  },
  info: {
    main: baseTheme.colors.lightBlue,
    light: baseTheme.colors.iconGrey,
    dark: baseTheme.colors.iconLightGrey,
  },
  text: {
    primary: baseTheme.colors.dark,
    secondary: baseTheme.colors.white,
    placeholder: baseTheme.colors.greyTurquoise,
  },
  error: {
    main: baseTheme.colors.red,
    light: baseTheme.colors.lightRed,
    contrastText: baseTheme.colors.darkRed,
  },
  success: {
    main: baseTheme.colors.green,
    light: baseTheme.colors.lightGreen,
  },
  background: {
    default: baseTheme.colors.white,
    grey: baseTheme.colors.greySoft,
    paper: baseTheme.colors.nearWhite,
  },
  border: {
    default: baseTheme.colors.lightGrey,
    hover: baseTheme.colors.middleDark,
    error: baseTheme.colors.red,
    focus: baseTheme.colors.middleDark,
  },
  action: {
    selected: baseTheme.colors.nearWhite,
    active: baseTheme.colors.iconGrey,
    focus: baseTheme.colors.greyTurquoise,
    hover: baseTheme.colors.nearWhite,
  },
}
